export default __webpack_public_path__ + "static/media/preview.7bf3f0ae.png";